// Copy is available in all seven product languages; the Admin language selector currently exposes three.
export const heartPhotoReviewCopy = {
  "zh-CN": {
    "status": "申诉状态",
    "title": "心动照片申诉审核",
    "notice": "普通广告允许展示。请查看原审核理由和申诉内容，再填写人工复核理由。",
    "pending": "待申诉审核",
    "approved": "人工通过",
    "rejected": "维持拒绝",
    "photoId": "照片 ID",
    "userId": "用户 ID",
    "createdAt": "申请时间（北京时间）",
    "moderationReason": "原审核理由",
    "appealReason": "申诉理由",
    "details": "查看详情",
    "approve": "人工通过",
    "reject": "维持拒绝",
    "decisionReason": "人工复核理由（必填）",
    "confirm": "确认决定",
    "cancel": "取消",
    "required": "请填写人工复核理由。",
    "failed": "操作失败，请稍后重试。",
    "conflict": "记录已变化，请刷新后重新审核。",
    "refresh": "刷新",
    "noRead": "无权查看照片申诉。",
    "noManage": "无审核权限，仅可查看。",
    "empty": "暂无申诉记录",
    "imageUnavailable": "图片无法预览，请刷新重新获取。",
    "saved": "审核决定已保存。"
  },
  "zh-TW": {
    "status": "申訴狀態",
    "title": "心動照片申訴審核",
    "notice": "一般廣告允許展示。請查看原審核理由與申訴內容，再填寫人工複核理由。",
    "pending": "待申訴審核",
    "approved": "人工通過",
    "rejected": "維持拒絕",
    "photoId": "照片 ID",
    "userId": "使用者 ID",
    "createdAt": "申請時間（北京時間）",
    "moderationReason": "原審核理由",
    "appealReason": "申訴理由",
    "details": "查看詳情",
    "approve": "人工通過",
    "reject": "維持拒絕",
    "decisionReason": "人工複核理由（必填）",
    "confirm": "確認決定",
    "cancel": "取消",
    "required": "請填寫人工複核理由。",
    "failed": "操作失敗，請稍後重試。",
    "conflict": "記錄已變更，請重新整理後再審核。",
    "refresh": "重新整理",
    "noRead": "無權查看照片申訴。",
    "noManage": "無審核權限，僅可查看。",
    "empty": "暫無申訴記錄",
    "imageUnavailable": "圖片無法預覽，請重新整理以重新取得。",
    "saved": "審核決定已儲存。"
  },
  "en-US": {
    "status": "Appeal status",
    "title": "Heart photo appeal review",
    "notice": "Ordinary advertising is allowed. Read the original review and appeal before entering your manual review reason.",
    "pending": "Pending appeals",
    "approved": "Approved manually",
    "rejected": "Rejection upheld",
    "photoId": "Photo ID",
    "userId": "User ID",
    "createdAt": "Submitted (China Standard Time)",
    "moderationReason": "Original review reason",
    "appealReason": "Appeal reason",
    "details": "View details",
    "approve": "Approve manually",
    "reject": "Uphold rejection",
    "decisionReason": "Manual review reason (required)",
    "confirm": "Confirm decision",
    "cancel": "Cancel",
    "required": "Enter a manual review reason.",
    "failed": "Operation failed. Please try again.",
    "conflict": "This record changed. Refresh before reviewing again.",
    "refresh": "Refresh",
    "noRead": "You cannot view photo appeals.",
    "noManage": "Read-only access. Review permission is required.",
    "empty": "No appeals",
    "imageUnavailable": "Image unavailable. Refresh to obtain a new preview.",
    "saved": "Review decision saved."
  },
  "ja-JP": {
    "status": "申し立て状況",
    "title": "心動写真の異議申し立て審査",
    "notice": "通常の広告は掲載できます。元の審査理由と申し立て内容を確認し、担当者の再審査理由を記入してください。",
    "pending": "審査待ちの申し立て",
    "approved": "担当者が承認",
    "rejected": "却下を維持",
    "photoId": "写真 ID",
    "userId": "ユーザー ID",
    "createdAt": "申請日時（中国標準時）",
    "moderationReason": "元の審査理由",
    "appealReason": "異議申し立ての理由",
    "details": "詳細を見る",
    "approve": "担当者として承認",
    "reject": "却下を維持",
    "decisionReason": "再審査の理由（必須）",
    "confirm": "決定を確定",
    "cancel": "キャンセル",
    "required": "再審査の理由を記入してください。",
    "failed": "操作に失敗しました。もう一度お試しください。",
    "conflict": "記録が変更されました。更新してから再審査してください。",
    "refresh": "更新",
    "noRead": "写真の異議申し立てを閲覧する権限がありません。",
    "noManage": "閲覧のみ可能です。審査権限が必要です。",
    "empty": "異議申し立てはありません",
    "imageUnavailable": "画像を表示できません。更新して再取得してください。",
    "saved": "審査の決定を保存しました。"
  },
  "es-ES": {
    "status": "Estado de la apelación",
    "title": "Revisión de apelaciones de fotos de Heart",
    "notice": "Se permite la publicidad habitual. Lee el motivo original y la apelación antes de escribir el motivo de la revisión manual.",
    "pending": "Apelaciones pendientes",
    "approved": "Aprobada manualmente",
    "rejected": "Rechazo confirmado",
    "photoId": "ID de foto",
    "userId": "ID de usuario",
    "createdAt": "Fecha de envío (hora de China)",
    "moderationReason": "Motivo original de la revisión",
    "appealReason": "Motivo de la apelación",
    "details": "Ver detalles",
    "approve": "Aprobar manualmente",
    "reject": "Mantener rechazo",
    "decisionReason": "Motivo de revisión manual (obligatorio)",
    "confirm": "Confirmar decisión",
    "cancel": "Cancelar",
    "required": "Escribe un motivo para la revisión manual.",
    "failed": "La operación falló. Inténtalo de nuevo.",
    "conflict": "El registro ha cambiado. Actualízalo antes de revisar.",
    "refresh": "Actualizar",
    "noRead": "No tienes permiso para ver las apelaciones.",
    "noManage": "Solo lectura. Se requiere permiso para revisar.",
    "empty": "No hay apelaciones",
    "imageUnavailable": "Imagen no disponible. Actualiza para obtener otra vista previa.",
    "saved": "Decisión guardada."
  },
  "ko-KR": {
    "status": "이의 신청 상태",
    "title": "하트 사진 이의 신청 심사",
    "notice": "일반 광고는 게시할 수 있습니다. 기존 심사 사유와 이의 신청 내용을 확인한 후 담당자의 재심사 사유를 입력하세요.",
    "pending": "심사 대기 중인 신청",
    "approved": "담당자 승인",
    "rejected": "거절 유지",
    "photoId": "사진 ID",
    "userId": "사용자 ID",
    "createdAt": "신청 시간 (중국 표준시)",
    "moderationReason": "기존 심사 사유",
    "appealReason": "이의 신청 사유",
    "details": "상세 보기",
    "approve": "담당자 승인",
    "reject": "거절 유지",
    "decisionReason": "재심사 사유 (필수)",
    "confirm": "결정 확인",
    "cancel": "취소",
    "required": "재심사 사유를 입력하세요.",
    "failed": "처리하지 못했습니다. 다시 시도하세요.",
    "conflict": "기록이 변경되었습니다. 새로고침 후 다시 심사하세요.",
    "refresh": "새로고침",
    "noRead": "사진 이의 신청을 볼 권한이 없습니다.",
    "noManage": "조회만 가능합니다. 심사 권한이 필요합니다.",
    "empty": "이의 신청이 없습니다",
    "imageUnavailable": "이미지를 볼 수 없습니다. 새로고침하여 다시 불러오세요.",
    "saved": "심사 결정이 저장되었습니다."
  },
  "ar-SA": {
    "status": "حالة الاعتراض",
    "title": "مراجعة الاعتراضات على صور هارت",
    "notice": "يُسمح بالإعلانات العادية. اطّلع على سبب المراجعة الأصلية والاعتراض قبل كتابة سبب المراجعة البشرية.",
    "pending": "اعتراضات بانتظار المراجعة",
    "approved": "مقبول بعد مراجعة بشرية",
    "rejected": "تم تأكيد الرفض",
    "photoId": "معرّف الصورة",
    "userId": "معرّف المستخدم",
    "createdAt": "وقت التقديم (توقيت الصين)",
    "moderationReason": "سبب المراجعة الأصلية",
    "appealReason": "سبب الاعتراض",
    "details": "عرض التفاصيل",
    "approve": "قبول بعد مراجعة بشرية",
    "reject": "تأكيد الرفض",
    "decisionReason": "سبب المراجعة البشرية (مطلوب)",
    "confirm": "تأكيد القرار",
    "cancel": "إلغاء",
    "required": "اكتب سبب المراجعة البشرية.",
    "failed": "تعذرت العملية. حاول مجددًا.",
    "conflict": "تغيّر السجل. حدّثه قبل إعادة المراجعة.",
    "refresh": "تحديث",
    "noRead": "ليس لديك إذن لعرض اعتراضات الصور.",
    "noManage": "يمكنك العرض فقط. يلزم إذن للمراجعة.",
    "empty": "لا توجد اعتراضات",
    "imageUnavailable": "الصورة غير متاحة. حدّث الصفحة للحصول على معاينة جديدة.",
    "saved": "تم حفظ قرار المراجعة."
  }
} as const;
export const heartPhotoReviewRouteLabel = Object.fromEntries(Object.entries(heartPhotoReviewCopy).map(([locale, copy]) => [locale, copy.title])) as Record<keyof typeof heartPhotoReviewCopy, string>;
